<template>
  <div class="inputContainer">
    <div :class="`inputView ${['post', 'activity_video'].includes(type) ? 'inputView--post' : 'inputView--comment'}`">
      <p class="tip" v-if="type === 'post'">
        社区仅限交流编程相关，请大家不要发无关信息，也不要公开自己的联系方式。若发现，老师将会删除哦~~
      </p>
      <div class="inputWrapper title" v-if="(type==='activity_video') || (type === 'post' && postType === 'video')">
        <div class="input">
          <input
            maxlength="15"
            placeholder="请输入视频主题(限制15个字)"
            v-model="input_data.title"
            @input="setPublishBtnState()"
            @keyup="keyupEvent($event)"
            @mouseup="mouseupEvent($event)"
          />
        </div>
      </div>

      <div class="inputWrapper content" ref="inputWrapper">
        <div
          class="avatar"
          v-if="type !== 'post' && avatar"
          :style="{ backgroundImage: `url(${getImg(avatar)})` }"
        ></div>
        <div class="input">
          <textarea
            ref="textarea"
            id="textarea"
            :placeholder="
              `${
                (type==='activity_video') || (type === 'post' && postType === 'video') ? '请输入视频简介(2000字以内)'
                : type === 'post' ? '你一定有什么新鲜想法(2000字以内)' : placeholder
              }`
            "
            v-model="input_data.content"
            @input="setPublishBtnState()"
            @keyup="keyupEvent($event)"
            @mouseup="mouseupEvent($event)"
          ></textarea>
        </div>
      </div>

      <div class="btns">
        <div class="btnsWrapper">
          <div v-if="['common', 'lego'].includes(postType) && type !== 'activity_video' " class="btn" @click="setLayerType($event, 'emoij')">
            <img :src="images.emoij" />
            <span v-if="type === 'post'">表情</span>
          </div>
          <div
            class="btn"
            @click="setLayerType($event, 'photo')"
            v-if="['common', 'lego'].includes(postType) && ['post', 'comment'].includes(type) "
          >
            <img :src="images.photo" />
            <span v-if="type === 'post'">图片</span>
          </div>
          <div
            class="btn"
            @click="setLayerType($event, 'video')"
            v-if="(type === 'activity_video') || (type === 'post' && ['video', 'lego'].includes(postType)) "
          >
            <img :src="images.video" />
            <span>视频</span>
          </div>
          <div class="btn" v-if="type === 'post' && postType === 'video' ">
            <input type="checkbox" v-model="input_data.is_circle" style="margin-right:5px;font-size:30px;"/>
            <span>同步到朋友圈</span>
            <!-- <el-checkbox v-model="checked">同步到朋友圈</el-checkbox> -->
          </div>
          <div
            class="btn"
            @click="setLayerType($event, '3d-model')"
            v-if="type === 'post' && postType === 'cube'"
          >
            <img :src="images.video" />
            <span>3D模型</span>
          </div>
          <div
            class="btn"
            @click="setLayerType($event, 'piskel')"
            v-if="type === 'post' && postType === 'piskel'"
          >
            <img :src="images.photo" />
            <span>像素图片</span>
          </div>
        </div>
        <div
          :class="`submit ${can_publish === false ? 'disable' : 'able'}`"
          @click="publish()"
        >
          {{ ['post', 'activity_video'].includes(type) ? "发布" : "评论" }}
        </div>
      </div>
    </div>
    <ResourceView
      v-if="layer_show"
      :offset-left="layer_arrow_offsetLeft"
      :type="layer_type"
    />
    <AttentionUser ref="attentionUser" />
  </div>
</template>
<script>
import {
  IMG_PHOTO_ORANGE,
  IMG_PHOTO_BLUE,
  IMG_VIDEO,
  IMG_EMOIJ,
  IMG_CLOSE,
  IMG_ADD,
  IMG_CLOSE_WHITE
} from "../../assets";
import { Utils, GET_VALUE } from "../../utils";
import { AT, ATTENTION_EVENT } from "../../utils/at.js";

import ResourceView from "./ResourceView";
import AttentionUser from "./AttentionUser";
import { types as ToastTypes } from "../../store/modules/toast";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "InputView",
  components: {
    ResourceView,
    AttentionUser
  },
  props: {
    type: {
      type: String,
      default: "post"
    },
    avatar: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    postType:{
      type: String,
      default: 'common'
    }
  },
  data() {
    return {
      images: {
        photo: IMG_PHOTO_ORANGE,
        video: IMG_VIDEO,
        photo_blue: IMG_PHOTO_BLUE,
        emoij: IMG_EMOIJ,
        close: IMG_CLOSE,
        add: IMG_ADD,
        close_white: IMG_CLOSE_WHITE
      },
      layer_show: false,
      layer_type: "emoij",
      layer_arrow_offsetLeft: 0,

      content: "",
      input_data: {
        content: "",
        is_circle: false
      },

      can_publish: false,
      attention_user: {}
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.login.userInfo
    })
  },

  methods: {
    ...mapMutations({
      showToast: ToastTypes.SHOW
    }),

    ...Utils,
    keyupEvent(e) {
      // console.log(e.target, e, e.target.clienHeight);
      if(!['activity_video'].includes(this.type)){
        this.test(e.target);
      }
    },
    mouseupEvent(e) {
      if(!['activity_video'].includes(this.type)){
        this.test(e.target);
      }
    },
    test(target) {
      ATTENTION_EVENT(target, (data, isAppend, left, top) => {
        // isAppend:光标的位置是否处于正确位置
        if (isAppend) {
          // console.log(data);
          // {"objString":objString, "indexString":indexString, "cursorPosition":cursorPosition, "atLocation":atLocation}
          // @与空格之间的字符串
          let indexString = data.indexString;
          this.indexString = indexString;
          // 输入框的字符串
          this.objString = data.objString;
          // 输入框字符串的长度
          this.objStringLength = data.objStringLength;
          // 光标的当前位置
          this.cursorPosition = data.cursorPosition;
          // 离光标最近的@的位置
          this.atLocation = data.atLocation;
          // 打开@用户列表框
          let searchString = indexString.substr(1, indexString.length);
          // 获取@用户列表
          if (searchString.length) {
            let left = this.$refs.inputWrapper.offsetLeft;
            let top = this.$refs.inputWrapper.offsetTop + this.$refs.inputWrapper.offsetHeight;
            this.$refs.attentionUser.showView(1,searchString,left,top);
          }
        } else {
          // 关闭@用户列表框
          if (target.id === "textarea") {
            this.$refs.attentionUser.hideView();
          } else if (target.id === "textarea1") {
            this.$refs.attentionUser1.hideView();
          }
        }
      });
    },
    // ----------------AttentionUser 组件的回调函数
    // 列表中用户的点击事件
    attentionUserEvent(name) {
      //将textarea分成三块，@之前的area1、@+联系人+' '的area2、光标之后的area3
      // 输入框的字符串
      let objString = this.objString;
      // 输入框字符串的长度
      let objStringLength = this.objStringLength;
      // 光标的当前位置
      let cursorPosition = this.cursorPosition;
      // 离光标最近的@的位置
      let atLocation = this.atLocation;

      var area1 = objString.substr(0, atLocation);
      var area2 = `@${name} `;
      var area3 = objString.substr(
        cursorPosition,
        objStringLength - cursorPosition
      );
      this.input_data.content = area1 + area2 + area3;

      //定位光标
      // var position = area1.length + area2.length;
      // this.textarea.setSelectionRange(position, position);
      // this.textarea.focus();
    },
    //设置资源选择视图的类型
    setLayerType(e, type) {
      // console.log(e);
      if (type !== this.layer_type) {
        this.resetInputData();
      }
      this.layer_arrow_offsetLeft = e.target.offsetLeft;
      this.layer_type = type;
      // 是评论且评论为photo才上传照片
      if(this.type === 'comment' && type === 'photo'){
        this.layer_type = "comment_photo"
      }
      this.layer_show = true;
    },
    //关闭资源选择视图
    closeLayerView() {
      this.layer_show = false;
      this.resetInputData();
    },
    // 清空图片数据
    deletePhoto(){
      if (this.input_data.hasOwnProperty("photos")) {
        delete this.input_data["photos"];
      }
    },
    // 清空视频数据
    deleteVideo(){
      if (this.input_data.hasOwnProperty("videos")) {
        delete this.input_data["videos"];
      }
      if (this.input_data.hasOwnProperty("poster_url")) {
        delete this.input_data["poster_url"];
      }
    },
    // 清空模型数据
    deleteModel(){
      if (this.input_data.hasOwnProperty("model_url")) {
        delete this.input_data["model_url"];
      }
    },

    //发布
    publish() {
      let input_data = { ...this.input_data };
      //console.log("发布:", this.type, input_data);
      if (this.can_publish) {
        if (input_data.content.includes("codemao")){
          this.showToast({ message: "帖子里包含非法链接，请删除再发送。" });
          return
        }
        // 新增乐高圈，根据圈子不同，把帖子发到不同的圈子
        input_data["types"] = this.postType

        if(this.type === 'post'){
          // 15 分钟限制
          console.log("发帖 15 分钟限制--判断")
          var time_str = GET_VALUE("lastSendPostTime")
          if(!this.userInfo.is_staff && time_str){
            var last_time = new Date(time_str)
            var current_time = new Date()
            var seconds = parseInt((current_time - last_time) / 1000)
            if(seconds > 0 && seconds <= 15*60){
              // 提示15分钟内只能发送一条信息
              // console.log("false")
              console.log("发帖 15 分钟限制--停止发帖")
              this.showToast({"message":"15分钟内只能发一条帖子"})
              return
            }
          }
          // console.log(this.input_data["content"].length,"1111")
          // if(this.input_data["content"].length > 1000){
          //   this.showToast({"message":"请把字数限制在一千字~"})
          //   return
          // }
        }
        console.log("发帖 15 分钟限制--开始发")
        
        if (this.$parent.publish) {
          this.$parent.publish(this.type, input_data);
          if(this.type === 'post'){
            localStorage["lastSendPostTime"] = new Date();
          }
        }else{
          this.$emit('publish', this.type, input_data);
        }
        this.input_data["content"] = "";
        this.deletePhoto()
        this.deleteVideo()
        this.deleteModel()

        this.closeLayerView();
      }
    },
    setPublishBtnState() {
      let input_data = { ...this.input_data };
      if (input_data.content.length > 2000) {
        this.showToast({ message: "请将字数控制在2000字以内" });
        this.input_data.content = input_data.content.slice(0, 2000);
        return;
      }
      if (input_data.content && input_data.videos && input_data.poster_url) {
        this.can_publish = true;
      } else if (input_data.content && input_data.photos) {
        this.can_publish = true;
      } else if (input_data.content) {
        this.can_publish = true;
      } else if (input_data.videos && input_data.poster_url) {
        this.can_publish = true;
      } else if (input_data.photos) {
        this.can_publish = true;
      } else if (input_data.model_url) {
        this.can_publish = true;
      } else {
        this.can_publish = false;
      }

      if(this.postType === 'cube' && this.type === 'post'){
        if(input_data.model_url){
          this.can_publish = true
        }else{
          this.can_publish = false
        }
      }

      if((this.type==='activity_video') || (this.postType === 'video' && this.type === 'post')){
        if(input_data.videos && input_data.poster_url && input_data.title){
          this.can_publish = true
        }else{
          this.can_publish = false
        }
      }

      if(this.postType === 'piskel' && this.type === 'post'){
        if(input_data.photos){
          this.can_publish = true
        }else{
          this.can_publish = false
        }
      }

    },
    resetInputData() {
      this.deletePhoto()
      this.deleteVideo()
      this.deleteModel()
      this.setPublishBtnState();
    },

    // ----------------ResourceView 组件的回调函数
    //设置上传成功的图片组
    setInputImages(images) {
      this.input_data["photos"] = images.join(",");

      this.deleteVideo()
      this.deleteModel()

      this.setPublishBtnState();
    },
    //设置表情
    setInputEmoijs(text) {
      this.input_data["content"] = this.input_data["content"] + text;
      console.log(this.input_data.content);
      this.setPublishBtnState();
    },
    //设置上传成功的视频
    setInputVideos(video_url) {
      this.input_data["videos"] = video_url;

      this.deletePhoto()
      this.deleteModel()

      this.setPublishBtnState();
    },
    //设置上传成功的视频的封面图
    setInputVideosPoster(poster_url) {
      this.input_data["poster_url"] = poster_url;

      this.deletePhoto()
      this.deleteModel()

      this.setPublishBtnState();
    },
    // 设置上传成功的模型
    setInputModel(model_url){
      this.input_data["model_url"] = model_url;

      this.deleteVideo()
      this.deletePhoto()

      this.setPublishBtnState();
    }
  },
  create() {},
  mounted() {}
};
</script>

<style scoped lang="less">
.inputContainer{
  position: relative;
}
.inputView--post {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 15px;
  width: calc(100% - 30px);
  border-radius: 5px;
  background-color: white;

  margin-bottom: 10px;
  // height: 170px;
  .tip {
    color: #4003fd;
    font-size: 13px;
    margin-bottom: 10px;
  }
  .inputWrapper {
    // flex: 1;
    display: flex;
    flex-direction: row;
    position: relative;
    overflow: hidden;
    padding: 0 10px;
    width: calc(100% - 20px);
    background-color: #f4f3f3;
    border-radius: 5px;
    &.content{
      height: 80px;
      padding: 10px;
    }
    &.title{
      height: 40px;
      margin-bottom: 10px;
    }
    .input {
      flex: 1;
      font-size: 12px;
      input {
        border: none;
        box-shadow: none;
        background-color: transparent;
        width: 100%;
        height: 100%;
        margin: 0px;
        padding: 0px;
        border-style: none;
        border-width: 0px;
        font-size: 14px;
        overflow-wrap: break-word;
        outline: none;
        color: #666666;
        word-wrap: break-word;
        word-break: break-word;
      }
      textarea {
        border: none;
        box-shadow: none;
        background-color: transparent;
        width: 100%;
        height: 100%;
        margin: 0px;
        padding: 0px;
        border-style: none;
        border-width: 0px;
        font-size: 14px;
        overflow-wrap: break-word;
        line-height: 18px;
        outline: none;
        color: #666666;
        word-wrap: break-word;
        word-break: break-word;
      }
    }
  }
  .btns {
    margin-top: 10px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .btnsWrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      .btn {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 20px;
        cursor: pointer;
        img {
          width: 20px;
          /* height: 20px; */
          /* background-color: #FF7B00; */
          margin-right: 5px;
        }
        span {
          font-size: 13px;
          color: #666666;
        }
      }
    }
  }
  .submit {
    background-color: #ff7b00;
    border-radius: 5px;
    padding: 2px 15px;
    color: #ffffff;
    cursor: pointer;
    &.disable {
      background-color: #e1e1e1;
    }
    &.able {
    }
  }
}
.inputView--comment {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 5px;
  .inputWrapper {
    flex: 1;
    display: flex;
    flex-direction: row;
    position: relative;

    .avatar {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .input {
      width: 100%;
      font-size: 12px;
      margin: 0 0 10px;

      textarea {
        margin: 0px;
        padding: 5px 2px 0px 6px;
        border: solid 1px #cccccc;
        font-size: 12px;
        overflow-wrap: break-word;
        line-height: 18px;
        overflow: hidden;
        outline: none;
        height: 23px;
        width: calc(100% - 10px);
        color: #333333;
        background-color: #fff;
        word-wrap: break-word;
        word-break: break-word;
        &:focus {
          border-color: #fa7d3c;
        }
      }
    }
  }

  .btns {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .btnsWrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      .btn {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 20px;
        cursor: pointer;
        img {
          width: 20px;
          height: 20px;
          /* background-color: orange; */
          margin-right: 5px;
        }
        span {
          font-size: 12px;
        }
      }
    }
  }
  .submit {
    background-color: #ff7b00;
    border-radius: 2px;
    padding: 3px 9px;
    color: #ffffff;
    font-size: 12px;
    cursor: pointer;
    &.disable {
      background-color: #e1e1e1;
    }
    &.able {
    }
  }
}

</style>
